import { EmptyState } from "@/components/molecules/empty-state";
import { ErrorState } from "@/components/molecules/error-state";
import { DataTable } from "@/components/molecules/tables/data-table";
import { useForms } from "@/features/qualifications/hooks/use-qualification-forms";
import { useTranslation } from "@/features/utils/i18n";
import { Button } from "@/components/ui/button";
import { ClipboardTextIcon, PlusIcon } from "@phosphor-icons/react";
import { useNavigate, useParams } from "react-router-dom";
import { PageLayout } from "../layout";
import { useFormsBulkActions } from "./components/bulk-actions";
import { useFormsColumns } from "./components/columns";

export function QualificationFormsPage() {
  const { t } = useTranslation("qualifications");
  const navigate = useNavigate();
  const { company: clientId } = useParams<{ company: string }>();
  const columns = useFormsColumns();
  const bulkActions = useFormsBulkActions();
  const { data: forms = [], isLoading, isError, refetch } = useForms();

  const handleCreateForm = () => {
    navigate(`/${clientId}/settings/qualification-forms/create`);
  };

  const createButton = (
    <Button onClick={handleCreateForm}>
      <PlusIcon className="size-4" />
      {t("forms.create")}
    </Button>
  );

  return (
    <PageLayout
      title={t("forms.title")}
      description={t("forms.description")}
      actions={createButton}
    >
      {isError ? (
        <ErrorState onRetry={refetch} />
      ) : !isLoading && forms.length === 0 ? (
        <EmptyState
          icon={ClipboardTextIcon}
          title={t("forms.empty.title")}
          description={t("forms.empty.description")}
          action={createButton}
        />
      ) : (
        <DataTable
          columns={columns}
          data={forms}
          isLoading={isLoading}
          hideSearch={true}
          bulkActions={bulkActions}
          onRowNavigate={(form) =>
            `/${clientId}/settings/qualification-forms/${form.id}/edit`
          }
        />
      )}
    </PageLayout>
  );
}
